<script setup lang="ts">
    import { computed, defineEmits, defineProps, reactive } from 'vue';

    const emit = defineEmits(["uploaded"]);
    const props = defineProps({
        id: { type: String, required: true },
        title: { type: String, required: true },
        description: { type: String, default: '' },
        url: { type: String, required: false },
        isUploaded: { type: Boolean, required: false },
        preview: { type: String }
    });
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });
    const previewComponent = computed(() => formValue.file_preview ?? props.preview);
    const isFileUploaded = computed(() => formValue.file ?? props.isUploaded);

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }
</script>
<template>
    <label :for="props.id" style="cursor: pointer;">
        <input :id="props.id" class="display-none" type="file" @change="onFileUploaded($event)" />
        <div v-if="isFileUploaded" style="width:280px;height:160px;padding:16px;border:2px solid #16a34a;border-radius:10px;display:flex;align-items:center;gap:14px;font-family:Arial, sans-serif;color:#065f46;position:relative; opacity: .3;">
            <div v-if="previewComponent" :style="{ background: `url('${previewComponent ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' }" style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;opacity: .2;">&nbsp;</div>
            <!-- Icône (document-check) -->
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style="flex-shrink:0;">
                <path d="M4 3h10l6 6v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" stroke="#065f46" stroke-width="1.5" fill="none"/>
                <path d="M14 3v6h6" stroke="#065f46" stroke-width="1.5" fill="none"/>
                <path d="M8 15l3 3 6-6" stroke="#16a34a" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
            <div style="display:flex;flex-direction:column;">
                <span style="font-size:15px;font-weight:bold;">
                    Fichier : {{ formValue.file_name || title }}
                </span>
                <span style="font-size:13px;color:#0f7a58;">
                    {{  description }}
                </span>
            </div>
        </div>
        <div v-if="!isFileUploaded" role="status" aria-live="polite" style="width:280px;height:160px;position:relative;border:2px dashed #cfcfcf;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-direction:column;color:#666;font-family:system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;background:#fafafa;">
            <div v-if="previewComponent" :style="{ background: `url('${previewComponent ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' }" style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;opacity: .2;">&nbsp;</div>
            <!-- petite icône inline SVG -->
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                style="margin-bottom:8px;opacity:.8;">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="#999" stroke-width="1.2" fill="none"/>
                <path d="M14 2v6h6" stroke="#999" stroke-width="1.2" fill="none"/>
                <path d="M8 13h8M8 17h5" stroke="#999" stroke-width="1.2" stroke-linecap="round"/>
            </svg>

            <div style="font-size:14px;font-weight:600;">{{ title }}</div>
            <div style="font-size:12px;margin-top:6px;color:#9a9a9a;">Aucun fichier uploadé</div>
        </div>
    </label>
</template>